import { getApiClient } from './client'

// --- Templates ---

export function listTemplates(holderType, holderId, params = {}) {
  return getApiClient()
    .get(`/esign/${holderType}/${holderId}/templates`, { params })
    .then((res) => {
      const payload = res.data.data ?? res.data
      // API may return an array, a paginated object { data: [], meta }, or a single object
      if (Array.isArray(payload)) return payload
      if (payload && typeof payload === 'object' && Array.isArray(payload.data)) return payload
      // Single object response (e.g. when fetching by Id)
      if (payload && typeof payload === 'object' && payload.id) return payload
      return []
    })
}

export function loadDefaultData(params = {}) {
  return getApiClient()
    .get('/esign/load-default-data', { params })
    .then((res) => res.data.data ?? [])
}

export function createTemplate(holderType, holderId, data) {
  return getApiClient()
    .post(`/esign/${holderType}/${holderId}/templates`, data)
    .then((res) => res.data.data ?? {})
}

export function updateTemplate(holderType, holderId, templateId, data) {
  return getApiClient()
    .put(`/esign/${holderType}/${holderId}/templates/${templateId}`, data)
    .then((res) => res.data.data ?? {})
}

export function deleteTemplate(holderType, holderId, templateId) {
  return getApiClient().delete(`/esign/${holderType}/${holderId}/templates/${templateId}`)
}

export function openTemplateEditor(holderType, holderId, templateId) {
  return getApiClient()
    .get(`/esign/${holderType}/${holderId}/templates/${templateId}/editor`)
    .then((res) => res.data.data?.editor_url ?? null)
}

// --- Signatures ---

export function listSignatures(signableType, signableId, params = {}) {
  return getApiClient()
    .get(`/esign/${signableType}/${signableId}/signatures`, { params })
    .then((res) => {
      const payload = res.data.data ?? res.data
      if (Array.isArray(payload)) return payload
      if (payload && typeof payload === 'object' && Array.isArray(payload.data)) return payload.data
      if (payload && typeof payload === 'object' && payload.id) return [payload]
      return []
    })
}

export function createSignature(signableType, signableId, payload) {
  return getApiClient()
    .post(`/esign/${signableType}/${signableId}/signatures`, payload)
    .then((res) => res.data)
}

export function updateSignature(signableType, signableId, signatureId, data) {
  return getApiClient()
    .put(`/esign/${signableType}/${signableId}/signatures/${signatureId}`, data)
    .then((res) => res.data.data ?? {})
}

export function sendSignature(signableType, signableId, signatureId) {
  return getApiClient()
    .post(`/esign/${signableType}/${signableId}/signatures/${signatureId}/send`)
    .then((res) => res.data)
}

export function downloadDocuments(signableType, signableId, signatureId) {
  return getApiClient()
    .get(`/esign/${signableType}/${signableId}/signatures/${signatureId}/documents`)
    .then((res) => res.data)
}

export function refreshStatus(signableType, signableId, signatureId) {
  return getApiClient()
    .get(`/esign/${signableType}/${signableId}/signatures/${signatureId}/refresh`)
    .then((res) => res.data)
}

export function deleteSignature(signableType, signableId, signatureId) {
  return getApiClient().delete(
    `/esign/${signableType}/${signableId}/signatures/${signatureId}`,
  )
}

export function getSigners(signableType, signableId, params = {}) {
  return getApiClient()
    .get(`/esign/${signableType}/${signableId}/signable-mapper-signers`, { params })
    .then((res) => res.data.data ?? [])
}
